/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TreatmentGoalModel } from '../../models/treatment-goal-model';

export interface GetPatientTreatmentGoals$Params {
  patientID?: number;
}

export function GetPatientTreatmentGoals(http: HttpClient, rootUrl: string, params?: GetPatientTreatmentGoals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TreatmentGoalModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientTreatmentGoals.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TreatmentGoalModel>>;
    })
  );
}

GetPatientTreatmentGoals.PATH = '/api/Supervisor/GetPatientTreatmentGoals';
